var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"manager-query-button",attrs:{"type":"primary","native-type":"submit","disabled":_vm.disabled}},[_vm._v("查询")])
}
var staticRenderFns = []

export { render, staticRenderFns }